// Copyright (c) 2023 Deere & Company

import t from 'tcomb';

const CscUserRoutingInfo = t.struct({
    csc2User: t.Boolean

}, 'CscUserRoutingInfo');

export const getDefaultState = () =>
    new CscUserRoutingInfo({
        csc2User: true
    });

export default CscUserRoutingInfo;



// WEBPACK FOOTER //
// ./src/user/shared/state/csc-user-routing-info.js